import { usePrivy } from "@privy-io/react-auth";
import { useEffect } from "react";
import { Navigate, Routes as ReactRoutes, Route, useLocation, useNavigate } from "react-router-dom";
import { isDevelopment } from "./config";
import { getJwt } from "./features/auth/utils";
import { Routes } from "./features/router";
import { ChangePartner } from "./flow/components/change-partner";
import { AccountSecurityWebauthnForcePage } from "./flow/components/gateways/signup/force-webauthn-page";
import { Layout } from "./flow/components/layout/Layout.react";
import FlowRoot from "./flow/index.react";
import ConsentDocumentsList from "./molecules/consent-document/ConsentDocumentsList.react";
import { TestSentry } from "./flow/components/gateways/test-sentry";
import { PassRoot } from "./views";
import { LoginPrivateRoutes } from "./privateRoutes/LoginPrivateRoutes";
import { PrivyPrivateRouteLayout } from "./privateRoutes/PrivyPrivateRouteLayout";
import { ConsentRoutes } from "./privateRoutes/ConsentRoutes";

export const InitialRouter = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { authenticated, logout } = usePrivy();

  useEffect(() => {
    if (pathname.indexOf("/sign-in/reset-password") === 0) {
      navigate(Routes.flow + "/-/login/reset" + search);
      return;
    }
    const handleLogout = async () => {
      if (!authenticated) return;
      return await logout();
    };
    const loggedIn = !!getJwt().token;

    if (!loggedIn) handleLogout();
    window.scrollTo(0, 0);
  }, [pathname]);

  //il faut mettre chaque private route
  return (
    <ReactRoutes>
      {isDevelopment && <Route path={Routes.flow + "/test-Sentry"} element={<TestSentry />} />}
      <Route path={Routes.flow}>{FlowRoot()}</Route>
      <Route path="/change-partner" element={<ChangePartner />} />
      <Route element={<LoginPrivateRoutes />}>
        <Route element={<PrivyPrivateRouteLayout />}>
          <Route path={Routes.pass}>{PassRoot()}</Route>
        </Route>
        <Route element={<ConsentRoutes />}>
          <Route path={Routes.document_consent} element={<ConsentDocumentsList />} />
        </Route>
        <Route
          path={Routes.force_webauthn}
          element={
            <Layout>
              <AccountSecurityWebauthnForcePage />{" "}
            </Layout>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to={Routes.pass} />} />
      <Route path="" element={<Navigate to={Routes.pass} />} />
    </ReactRoutes>
  );
};
